import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Tooltip from '@/components/atoms/tooltip/Tooltip.vue';
import { TextInputData, SelectInputData, CheckboxInputData, DateInputData, NumberInputData, MapData } from './types';
import SelectInput from './SelectInput.vue';
import TextInput from './TextInput.vue';
import NumberInput from './NumberInput.vue';
import CheckboxInput from './CheckboxInput.vue';
import DateInput from './DateInput.vue';
import GoogleMap from './GoogleMap.vue';

export interface InputGroupProps {
    data: MapData | TextInputData | CheckboxInputData | DateInputData | NumberInputData | SelectInputData;
    hideLabel?: boolean;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
    onInputReady?: (input: HTMLInputElement | null) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroup',
  props: {
    data: null,
    hideLabel: { type: Boolean },
    onBlur: null,
    onPaste: null,
    onInputReady: null
  },
  emits: ["enter"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    data: MapData | TextInputData | CheckboxInputData | DateInputData | NumberInputData | SelectInputData;
    hideLabel?: boolean;
    onBlur?: (value: any) => void;
    onPaste?: (event: ClipboardEvent) => void;
    onInputReady?: (input: HTMLInputElement | null) => void;
};





const emitEnter = () => {
    emit('enter');
};

const errorMessage = computed(() => props.data.errorMessage || 'Campo inválido');
const hasError = computed(() => Boolean(props.data.error || props.data.errorMessage));

const getComponentForField = () => {
    switch (props.data.type) {
        case 'select':
            return SelectInput;
        case 'number':
            return NumberInput;
        case 'checkbox':
            return CheckboxInput;
        case 'date':
            return DateInput;
        case 'google-map':
            return GoogleMap;
        default:
            return TextInput;
    }
};


return { __sfc: true,props, emit, emitEnter, errorMessage, hasError, getComponentForField, Tooltip }
}

})